import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { forkJoin, Subject } from 'rxjs';
import { Config } from 'datatables.net-dt';

@Component({
	selector: 'app-configurazione-cliente',
	templateUrl: './configurazione-cliente.component.html',
})
export class ConfigurazioneClienteComponent implements OnInit, OnDestroy {
	constructor(private api: ApiService) {}

	mercati = [];
	clienti = [];
	clientiPlm = [];
	utenti = [];

	dropdownSettings = {
		singleSelection: false,
		textField: 'codiceMercato',
		selectAllText: 'Seleziona tutti',
		unSelectAllText: 'Deseleziona tutti',
		itemsShowLimit: 5,
		allowSearchFilter: false,
	};

	dtTrigger: Subject<any> = new Subject<any>();
	dtSettings: Config = {
		columnDefs: [
			{ searchable: true, targets: 0, orderable: true },
			{ searchable: false, targets: 1, orderable: false },
			{ searchable: false, targets: 2, orderable: false },
			{ searchable: false, targets: 3, orderable: false },
			{ searchable: false, targets: 4, orderable: false },
			{ searchable: false, targets: 5, orderable: false },
		],
	};

	ngOnInit() {
		const s1 = this.api.getMercati();
		const s2 = this.api.getClienti();
		const s3 = this.api.getClientiPLM();
		const s4 = this.api.getUtenti();

		forkJoin([s1, s2, s3, s4]).subscribe(([mercati, clienti, clientiPLM, utenti]) => {
			this.utenti = utenti.filter((u) => u.ruolo === 'BACKOFFICE');
			this.mercati = mercati;
			this.mercati.sort((a, b) => a.codiceMercato.localeCompare(b.codiceMercato)); //Ordering Alphabetically;

			this.clienti = clienti;
			this.clientiPlm = clientiPLM;

			this.clienti.forEach((c) => {
				c.jsonIn = {};
				c.jsonIn.idAs400 = c.id;
				c.jsonIn.idPlm = c.clientePlm ? c.clientePlm.id : null;
				c.jsonIn.idMercati = c.mercato.map((m) => m.id);
				c.jsonIn.tipoEvasione = c.tipoEvasione;
				c.jsonIn.idUtenteCustomerSupport = c.utenteCustomerSupport ? c.utenteCustomerSupport.id : null;
			});

			this.dtTrigger.next();
		});
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	save(cliente) {
		cliente.jsonIn.idPlm = cliente.jsonIn.idPlm / 1;
		cliente.jsonIn.idMercati = cliente.mercato.map((m) => m.id);
		this.api.associaCliente(cliente.jsonIn).subscribe((res) => {
			if (res) {
				cliente.feEdit = false;
			} else {
				alert('non é stato possibile salvare la configurazione');
			}
		});
	}
}
